<template>
  <div>
      <Message v-if="!domain.is_enabled" severity="warn">Domain is disabled</Message>
      <Breadcrumb :home="bc_home" :model="bc_items" />
      <DomainNavBar :domain="domain"/>

      <Panel header="Dashboard" class="p-mt-2">
        
        Domain dashboard
        
      </Panel>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DomainNavBar from '../components/DomainNavBar.vue'

export default {
  name: 'Domain',
  components: {
    DomainNavBar,
  },
  data () {
    return {
      domain: {id: null, name: "", attributes: [], is_enabled: true},
      bc_home: {icon: 'pi pi-home', to: '/domains'},
      bc_items: [
          {icon: 'pi pi-spin pi-spinner'},
      ]
    }
  },
  computed: {
    ...mapGetters({ Domains: 'StateDomains', GetDomain: 'GetDomain' }),
  },
  created: function () {
    this.domain = {id: null, name: "", attributes: [], is_enabled: true},
    this.GetDomain(this.$route.params.domain_id)
      .then(response => {
        this.domain = response
        this.bc_items = [
          {label: this.domain.name, to: '/domains/'+this.$route.params.domain_id},
        ]
      })
  },
  methods: {
    //...mapActions(['CreateDomain', 'GetDomains']),
    //async submit () {
    //  await this.CreateDomain(this.form)
    //},
    //async selectDomain(id) {
    //  console.log("selectDomain", id)
    //  this.$router.push('/domains/' + id + '/mail/accounts')
    //  
    //}
  }
}
</script>

<style scoped>

</style>
